import { createAsyncThunk } from '@reduxjs/toolkit'
import { BomItemController } from 'controllers/Project/BomItemController'
import { NestingDirection } from 'services/APIs/InternalAPI/internal-api.contracts'
import { newProjectActions } from '../newProjectReducer'
import { fetchProject } from './fetchProject'
import { GetContext } from 'store/storeUtils'

export const saveNestingDirection = createAsyncThunk<any, any, { state: any }>(
  'bom/save-nesting-direction',
  async (
    {
      bomItemId,
      nestingDirection,
    }: {
      bomItemId: string
      nestingDirection: NestingDirection
    },
    thunkAPI
  ) => {
    const bomItemController = new BomItemController()
    const { projectId } = GetContext()

    try {
      thunkAPI.dispatch(
        newProjectActions.setBomItemProperties({
          id: bomItemId,
          selectedNestingDirection: nestingDirection,
        })
      )

      await bomItemController.SetNestingDirection(bomItemId, nestingDirection)
    } catch (err) {
      thunkAPI.dispatch(fetchProject({ projectId: projectId }))
      throw err
    }
  }
)
